


























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { UserResourceInAdminModel } from '@/modules/user/models/user-resource.model'
import AdminBillingInfoBaseForm from '@/modules/billing-info/components/admin/AdminBillingInfoBaseForm.vue'
import {
  AdminUpdateUserBillingInfoUseCase
} from '@/modules/user/use-cases/admin/admin-update-user-billing-info.use-case'
import { BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import { BillingInfoRequestModel } from '@/modules/billing-info/models/billing-info-request.model'

@Component({
  components: {
    AdminBillingInfoBaseForm,
    BaseButton
  }
})
export default class AdminUserBillingInfoForm extends Vue {
  constructor(
    private readonly useCase: AdminUpdateUserBillingInfoUseCase
  ) {
    super()
  }

  @Prop({ required: true }) userResource: UserResourceInAdminModel
  @Prop({ required: true }) billingInfoTypes: { [key in BillingInfoType]: string }

  protected requestData: BillingInfoRequestModel = this.userResource.billing_info

  protected onSubmit() {
    this.useCase.execute(this.userResource.id, this.requestData)
  }
}
